import React from 'react'
import { Box, Typography } from '@mui/material'
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import TokTokDocDialog from '../../../Common/Dialog'
import { usePatientFormContext } from '../../context/PatientFormContext'
import Callout from '../../../Common/callout/Callout'
import sxs from './_sxs'
import { defaultPalette } from '../../../../theme/idsTheme'

const PatientInsiResultDialog: React.FC = () => {
    const { state, update } = usePatientFormContext()

    const handleClose = () => {
        update({
            insiResultDialogOpen: false,
        })
    }

    return (
        <TokTokDocDialog
            title="Résultat de la vérification INS"
            isOpen={state.insiResultDialogOpen}
            maxWidth="45rem"
            saveTitle="J'ai compris"
            cancelTitle={
                <>
                    Voir la liste <ArrowOutwardRoundedIcon />
                </>
            }
            handleSave={handleClose}
            handleClose={handleClose}
            handleCancel={() => {
                window.open(`${window.origin}/patients-workbench`, '_blank')?.focus()
                handleClose()
            }}
            buttonsOptions={{
                colors: {
                    save: defaultPalette.typography.main,
                },
            }}
        >
            <Box sx={sxs.PatientInsiResultDialogContent}>
                <Callout color={defaultPalette.orangeWarning.main}>
                    <Typography>
                        Le statut INS du patient a été rétrogradé du statut “qualifié” à “provisoire” car l’un de ses
                        cinq traits stricts d’identité a changé. Veuillez mettre à jour les informations du patient et
                        relancer un appel pour récupérer son INS.
                    </Typography>
                </Callout>
                <Callout icon={<CheckRoundedIcon />}>
                    <Typography>
                        Ce patient a été ajouté à la liste des identités en attente de traitement. Cette liste est
                        accessible depuis le bouton “INS” de la liste patient.
                    </Typography>
                </Callout>
            </Box>
        </TokTokDocDialog>
    )
}

export default PatientInsiResultDialog
